import { render, staticRenderFns } from "./smsPanel.vue?vue&type=template&id=1328a27d&"
import script from "./smsPanel.vue?vue&type=script&lang=js&"
export * from "./smsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports